import BaseCollectiveLogListItem from './BaseCollectiveLogListItem'
import { ICollectiveLogListItemProps } from './common'

const CollectiveLogDataOnAnnouncementDeleted: React.FC<
  ICollectiveLogListItemProps<'CollectiveLogDataOnAnnouncementDeleted'>
> = ({ bundledCollectiveLog, isLast }) => (
  <BaseCollectiveLogListItem
    isLast={isLast}
    bundle={bundledCollectiveLog}
    summaryActionText={`deleted 
          ${
            bundledCollectiveLog.logs.length > 1
              ? `${bundledCollectiveLog.logs.length} announcements`
              : `an announcement`
          }     
    `}
    detailsActionText={log =>
      `deleted an announcement: "${log.data.announcement.bodyHtml?.replace(
        /(<([^>]+)>)/gi,
        ''
      )}"`
    }
  />
)

export default CollectiveLogDataOnAnnouncementDeleted
